import { api } from './api';

/** O Cloudflare, na frente da API, recusa corpo acima de 100 MB; um pouco abaixo disso ainda dá para ir pela API. */
const VIA_API_MAX = 95 * 1024 * 1024;

type Start = { direct: false } | { direct: true; url: string; method: 'PUT'; headers: Record<string, string>; token: string };

function put(url: string, file: File, headers: Record<string, string>, onProgress?: (pct: number) => void) {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    for (const [k, v] of Object.entries(headers)) xhr.setRequestHeader(k, v);
    xhr.upload.onprogress = (e) => { if (e.lengthComputable) onProgress?.(Math.round((e.loaded / e.total) * 100)); };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`o armazenamento recusou o arquivo (${xhr.status})`)));
    xhr.onerror = () => reject(new Error('não consegui enviar o arquivo ao armazenamento'));
    xhr.send(file);
  });
}

/**
 * Envia o arquivo direto do navegador ao armazenamento (sem passar pela API) e devolve o recibo, que a rota de quem
 * consome confere. `null` = o envio direto não está disponível (disco local, ou o armazenamento recusou um arquivo
 * pequeno) e quem chama manda pela API, como antes. Arquivo grande sem envio direto é erro com o que fazer.
 */
export async function uploadDirect(organizationId: string, purpose: string, file: File, onProgress?: (pct: number) => void): Promise<string | null> {
  const start = await api.post<Start>(`/organizations/${organizationId}/uploads`, { purpose, name: file.name, mimeType: file.type || 'application/octet-stream', sizeBytes: file.size });
  if (!start.direct) {
    if (file.size > VIA_API_MAX) throw new Error('o arquivo passa de 95 MB e este ambiente não envia direto ao armazenamento: reduza antes de subir');
    return null;
  }
  try {
    await put(start.url, file, start.headers, onProgress);
  } catch (e) {
    if (file.size <= VIA_API_MAX) return null;
    throw new Error(`${(e as Error).message}: tente de novo; se continuar, avise a equipe (pode ser a permissão do armazenamento)`);
  }
  return start.token;
}
